module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding-md"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.searchForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.searchForm.name),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "name", $$v)
      },
      expression: "searchForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.loadData
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.showDialog()
      }
    }
  }, [_vm._v("添加")])], 1)], 1)], 1), _vm._v(" "), (_vm.loadedData) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.loadedData.rows,
      "stripe": true,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "product-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "商品描述"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.description))])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "min-width": "60",
      "max-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "icon",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hotStatus",
      "label": "商品状态",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.findProductStatus(scope.row.hotStatus)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "category",
      "label": "商品类别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.findProductType(scope.row.category)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sellType",
      "label": "出售货币类型",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.findSellType(scope.row.sellType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "价格：元/钻石数",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("currency")(scope.row.price)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sellCount",
      "label": "数量",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "timeLimit",
      "label": "限时道具",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatTimeLimit(scope.row.timeLimit)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemId",
      "label": "道具编号",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.showDialog(scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.deleteProduct(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "padding-vertical-md",
    attrs: {
      "background": "",
      "current-page": _vm.loadedData.currentPage,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.loadedData.pageSize,
      "page-count": _vm.loadedData.totalPages,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.loadedData.count
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.$set(_vm.loadedData, "currentPage", $event)
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "update",
    attrs: {
      "el-dialog": "",
      "title": _vm.title,
      "visible": _vm.showEditorDialog,
      "before-close": _vm.handleBeforeCloseDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditorDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "formData",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品编号",
      "prop": "id"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.formData.id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formData.id"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formData.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品icon",
      "prop": "icon"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.formData.icon),
      callback: function($$v) {
        _vm.$set(_vm.formData, "icon", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formData.icon"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品类别",
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.dropDownEvent
    },
    model: {
      value: (_vm.formData.category),
      callback: function($$v) {
        _vm.$set(_vm.formData, "category", $$v)
      },
      expression: "formData.category"
    }
  }, _vm._l((_vm.productType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "商品状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.hotStatus),
      callback: function($$v) {
        _vm.$set(_vm.formData, "hotStatus", $$v)
      },
      expression: "formData.hotStatus"
    }
  }, _vm._l((_vm.productStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "出售货币"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": true
    },
    model: {
      value: (_vm.formData.sellType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sellType", $$v)
      },
      expression: "formData.sellType"
    }
  }, _vm._l((_vm.sellType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "md": 18
    }
  }, [_c('el-form-item', {
    staticClass: "form-item__full-width",
    attrs: {
      "label": "价格：",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    staticClass: "priceInput",
    attrs: {
      "controls": false,
      "min": 0
    },
    model: {
      value: (_vm.formData.price),
      callback: function($$v) {
        _vm.$set(_vm.formData, "price", $$v)
      },
      expression: "formData.price"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "inline-block",
      "padding-left": "8px"
    }
  }, [_vm._v("备注：分/钻石")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    staticClass: "form-item__full-width",
    attrs: {
      "label": "数量",
      "prop": "sellCount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "min": 0
    },
    model: {
      value: (_vm.formData.sellCount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sellCount", $$v)
      },
      expression: "formData.sellCount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "商品描述"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formData.description),
      callback: function($$v) {
        _vm.$set(_vm.formData, "description", $$v)
      },
      expression: "formData.description"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "限时道具"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formData.timeLimit),
      callback: function($$v) {
        _vm.$set(_vm.formData, "timeLimit", $$v)
      },
      expression: "formData.timeLimit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "道具ID",
      "prop": "itemId"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.formData.itemId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "itemId", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formData.itemId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "native-type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45e81246","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/products.vue
// module id = NVIe
// module chunks = 3